export default "__VITE_ASSET__txvbFL1M__"